import { capitalizeString } from 'lib/helpers'
import type { LocaleCurrency } from 'types/Shared/Locale'
import 'types/Shared/Locale'
import { convertDefaultToLocaleCurrency, getCurrencySymbol } from 'components/FormatPrice/helpers'
import * as Constants from './constants'
import * as Facets from './facets'
import * as MetaData from './metadata'
// Remove Excess Whitespace
// ' Abstract   Art From United States    For Sale  ' => 'Abstract Art From United States For Sale'
export const stringCleanup = (value: string): string => value.replace(/^\s+|\s+$|\s+(?=\s)/g, '')
export const prettyCategory = (category: string | null | undefined): string => {
  if (!category) {
    return 'Art'
  }

  return category
    .replace(/^Mixed Media$/i, 'Mixed Media Art')
    .replace(/^Printmaking$/i, 'Art Prints')
    .replace(/^Digital$/i, 'Digital Art')
    .replace(/^Installation$/i, 'Art Installations')
    .replace(/^all$/i, 'Art')
}
export const getPriceLabel = (selectedCurrency: LocaleCurrency, priceValue: string): string => {
  const currencySymbol = getCurrencySymbol(selectedCurrency)
  const priceMappingObject = {
    '0-500': `Under ${currencySymbol}500`,
    '0-200': `Under ${currencySymbol}200`,
    '500': `Over ${currencySymbol}500`,
    '10000-500000': `Over ${currencySymbol}10,000`,
  }
  const splitPrice = priceValue.split('-')
  const price = splitPrice.map((value) =>
    convertDefaultToLocaleCurrency(parseInt(value, 10), selectedCurrency)
  )
  const priceString = price.join('-')
  const priceTitle = Object.keys(priceMappingObject).some((ele) => ele === priceString)
    ? priceMappingObject[priceString]
    : `${currencySymbol}${price[0]} - ${currencySymbol}${price[1]}`
  return priceTitle
}

export const getSortOptionsByZone = (zone: string) => {
  const isZoneWithSorting = Constants.geoPricingSortZonesList.includes(zone)
  const defaultSortOptions = [
    'default',
    'newest',
    ...(isZoneWithSorting ? [`price-low`, `price-high`] : []),
  ]

  const sortOptions = Constants.geoPricingSortOptions.filter(({ value }) =>
    defaultSortOptions.includes(value)
  )

  return sortOptions
}

export default {
  ...Constants,
  ...Facets,
  ...MetaData,
  stringCleanup,
  prettyCategory,
  capitalizeString,
}